/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type CartToggleAutoshipMutationInput = {
    readonly clientMutationId?: string | null;
};
export type CartToggleAutoshipMutationVariables = {
    readonly input: CartToggleAutoshipMutationInput;
};
export type CartToggleAutoshipMutationResponse = {
    readonly cartToggleAutoship: ({
        readonly cart: ({
            readonly id: string;
            readonly autoShipEnabled: boolean | null;
            readonly autoShipIntervalUnit: string | null;
            readonly autoShipIntervalCount: number | null;
            readonly enrollingAsPc: boolean | null;
            readonly total: number | null;
            readonly subTotalPriceOfItems: number | null;
            readonly subTotalPriceOfItemsWithPromoCodes: number | null;
        }) | null;
    }) | null;
};
export type CartToggleAutoshipMutation = {
    readonly response: CartToggleAutoshipMutationResponse;
    readonly variables: CartToggleAutoshipMutationVariables;
};



/*
mutation CartToggleAutoshipMutation(
  $input: CartToggleAutoshipMutationInput!
) {
  cartToggleAutoship(input: $input) {
    cart {
      id
      autoShipEnabled
      autoShipIntervalUnit
      autoShipIntervalCount
      enrollingAsPc
      total
      subTotalPriceOfItems
      subTotalPriceOfItemsWithPromoCodes
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "CartToggleAutoshipMutationInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "cartToggleAutoship",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input",
                    "type": "CartToggleAutoshipMutationInput!"
                }
            ],
            "concreteType": "CartToggleAutoshipMutationPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "cart",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Cart",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "id",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "autoShipEnabled",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "autoShipIntervalUnit",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "autoShipIntervalCount",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "enrollingAsPc",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "total",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "subTotalPriceOfItems",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "subTotalPriceOfItemsWithPromoCodes",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "CartToggleAutoshipMutation",
            "type": "Mutation",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "CartToggleAutoshipMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "CartToggleAutoshipMutation",
            "id": null,
            "text": "mutation CartToggleAutoshipMutation(\n  $input: CartToggleAutoshipMutationInput!\n) {\n  cartToggleAutoship(input: $input) {\n    cart {\n      id\n      autoShipEnabled\n      autoShipIntervalUnit\n      autoShipIntervalCount\n      enrollingAsPc\n      total\n      subTotalPriceOfItems\n      subTotalPriceOfItemsWithPromoCodes\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'cfc2e5b56b06296ba438e95e68b8adda';
export default node;
